import * as React from 'react'

import { Box, Chevron, Popover, type Text, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import TooltipHeader from 'modules/attendance/components/ClockIn/Tooltip/Header'
import TooltipRow from 'modules/attendance/components/ClockIn/Tooltip/Row'
import MinutesToText from 'modules/attendance/components/MinutesToText'
import { AggregatedEstimatedTime } from 'modules/attendance/lib/utils/EstimatedTimes'

type SizeType = React.ComponentProps<typeof Text>['size']
type WeightType = React.ComponentProps<typeof Text>['weight']

export interface Props {
  size?: SizeType
  weight?: WeightType
  children?: React.ReactNode
  estimatedTime: AggregatedEstimatedTime
}

export const EstimatedHours = ({ size, weight, children, estimatedTime }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <>
      <Popover.ItemList attachment="bottom center" toggle={toggle} open={open} gapDivider={false}>
        <Box inline flexDirection="row" gap="s8" alignItems="center">
          <MinutesToText value={estimatedTime.minutes} size={size} weight={weight} />
          <Chevron direction={open ? 'up' : 'down'} type="terciary" />
        </Box>
        <TooltipHeader
          title={i18n.t('time_tracking.estimated.title')}
          minutes={estimatedTime.regularMinutes + estimatedTime.overtimeMinutes}
        />
        <TooltipRow
          label={i18n.t('time_tracking.estimated.regular')}
          value={estimatedTime.regularMinutes}
        />
        <TooltipRow
          label={i18n.t('time_tracking.estimated.overtime')}
          value={estimatedTime.overtimeMinutes}
        />
      </Popover.ItemList>
      {children}
    </>
  )
}
